import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { catchError, combineLatest, of, shareReplay, switchMap, tap } from 'rxjs';
import { PanelService } from 'src/app/dashboards/panels/services/panel/panel.service';
import { VisibleDirective, waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { IClimateOverviewCardItem } from 'src/app/panels/models/cards';
import { ClimateBadgePipe } from 'src/app/panels/pipes/climate-badge.pipe';
import { ClimateIconClassPipe } from 'src/app/panels/pipes/climate-icon-class.pipe';
import { ClimateIconPipe } from 'src/app/panels/pipes/climate-icon.pipe';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { PanelComponent } from '../../panel.component';

export const CLIMATE_OVERVIEW_CARD_PANEL_IMPORTS: Type<unknown>[] = [
  CardComponent,
  VisibleDirective,
  AsyncPipe,
  RouterLink,
  ClimateBadgePipe,
  ClimateIconClassPipe,
  ClimateIconPipe,
];

@Component({
  selector: 'app-climate-overview-card-panel',
  templateUrl: './climate-overview-card-panel.component.html',
  styleUrls: ['./climate-overview-card-panel.component.scss'],
  imports: CLIMATE_OVERVIEW_CARD_PANEL_IMPORTS,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'col-12',
  },
})
export abstract class ClimateOverviewCardPanelComponent extends PanelComponent implements OnInit {
  protected items: IClimateOverviewCardItem[] = [];
  protected message: string | null = null;
  protected panelService = inject(PanelService);

  ngOnInit(): void {
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) =>
        this.panelService
          .getClimateOverviewCard(this.getType(), this.entityIds, params.timeRange.from, params.timeRange.till)
          .pipe(
            catchError(() => {
              this.error = 'Geen data';
              return of(null);
            }),
          ),
      ),
      tap((data) => {
        this.items = data?.card?.items ?? [];
        this.message = data?.message ?? null;
        this.loading = false;
      }),
      shareReplay(1),
    );
  }
}
